import React, { useEffect, Fragment } from "react";
import Slider from "../../components/Slider";
import Stage from "../../components/Stage";
import Header from "../../components/layout/Header";
import Banner from "../../components/Banner";
import bannerArticles from "../../data/bannerArticles";
import { useDispatch } from "react-redux";
import { setCategoriasAction } from "../../actions/searchActions";
import { 
    getCategoriasR as getCats,
    getArticulosR as getArts,
    jsonDeserialize
} from "../../API/request";
import Loading from "../../components/Loading";
import BtnSubir from "../../components/BtnSubir";

const Home = () => {
    const dispatch = useDispatch();
    const showPrice = process.env.REACT_APP_SHOW_PRICE  === 'false' ? false : true;
    const showBanner = process.env.REACT_APP_SHOW_BANNER  === 'false' ? false : true;

    const [showLoading, setShowLoading] = React.useState(true);
    const [listadoCategorias, setListadoCategorias] = React.useState(null);
    const [listadoNuevos, setListadoNuevos] = React.useState([]);
    const [listadoDestacados, setListadoDestacados] = React.useState([]);

    useEffect(() => {
        document.title = "Home";
        window.scrollTo(0, 0)

        setListadoCategorias(null);
        setListadoNuevos([]);
        setListadoDestacados([]);
        
        var generalNuevos = [];
        var generalDestacados = [];

        getCats()
            .then( ( responseCategorias ) => {
                let cats = jsonDeserialize(responseCategorias.data.data).data;
                setListadoCategorias(cats);
                dispatch(setCategoriasAction(cats));

                const promesasArticulos = cats.map( (cat) => getArts(cat.idCategoria) );

                Promise.all(promesasArticulos)
                .then( ( respuestas ) => {
                    respuestas.forEach( ( responseArticulos ) => {
                        var arts = jsonDeserialize(responseArticulos.data.data).articulos.data;
                        var item_generalNuevos = arts.filter( (item) =>  item.nuevo === "True");
                        var item_generalDestacados = arts.filter( (item) =>  item.destacado === "True");

                        generalNuevos.push.apply(generalNuevos, item_generalNuevos);
                        generalDestacados.push.apply(generalDestacados, item_generalDestacados);
                    });

                    const nuevosSinDuplicados = [...new Map(generalNuevos.map(item => [item.numParte, item])).values()];
                    const destacadosSinDuplicados = [...new Map(generalDestacados.map(item => [item.numParte, item])).values()];

                    setListadoNuevos(nuevosSinDuplicados);
                    setListadoDestacados(destacadosSinDuplicados);
                    setShowLoading(false);

                    window.scrollTo(0, 0)
                })
                .catch((errorMessageGetMantenimiento)=>{
                    console.log("ERORR - En la petición")
                })
            })
            .catch((errorMessageGetMantenimiento)=>{
                console.log("ERORR - En la petición")
            });
    }, [dispatch,setShowLoading,setListadoCategorias,setListadoNuevos,setListadoDestacados]);

    return (
        <Fragment>
            {
                showLoading
                ?   <Loading/>
                :   <>
                        <Header/>
                        <div className="content">
                            {
                                showBanner &&
                                    <>
                                        <Banner
                                            title="Team Collection"
                                            subtitle="Audi Revolut F1®"
                                            description="Lleva tu estilo a la máxima velocidad."
                                            imageMobile="https://www.appsaudi.com.mx/resources/images/boutique/banner/Banner_f1_movil.jpg"
                                            imageDesktop="https://www.appsaudi.com.mx/resources/images/boutique/banner/Banner_f1_desktop.jpg"
                                            catalogUrl="https://www.appsaudi.com.mx/catalogo_audi_collection/formula1/es.html"
                                            catalogText="Catálogo digital"
                                            articles={false}
                                        />
                                        <Banner
                                            title="Comparte todo el estilo"
                                            subtitle="Audi en familia"
                                            description="Descubre toda la gama de Audi collection y complementa tu estilo de vida."
                                            imageMobile="https://www.appsaudi.com.mx/resources/images/boutique/banner/Banner_Movil.jpg"
                                            imageDesktop="https://www.appsaudi.com.mx/resources/images/boutique/banner/Banner_Desktop.jpg"
                                            catalogUrl="https://www.appsaudi.com.mx/catalogo_audi_collection/new.html"
                                            catalogText="Catálogo digital"
                                            imagePosition="right"
                                            articles={bannerArticles}
                                            imageDisclaimer="*Imágenes de carácter ilustrativo"
                                        />
                                    </>
                            }
                            {
                                listadoCategorias !== null &&
                                    listadoCategorias.map( (collectionDetail, i) =>
                                        <Stage 
                                            type="Collection"
                                            title={collectionDetail.nombre}
                                            description={collectionDetail.descripcion}
                                            image={ collectionDetail.img}
                                            idCollection={collectionDetail.idCategoria}
                                            key={ "stIt_" + i }
                                        />
                                    )
                            }
                            {
                                listadoNuevos.length > 0 &&
                                    <Slider
                                        title="Nuevos"
                                        articulos={listadoNuevos}
                                        showPrice={showPrice}
                                        showTallas={false}
                                    />
                            }   
                            {
                                listadoDestacados.length > 0 &&
                                    <Slider
                                        title="Destacados"
                                        articulos={listadoDestacados}
                                        showPrice={showPrice}
                                        showTallas={false}
                                    />
                            } 
                        </div>
                        <BtnSubir />
                    </>
            }
        </Fragment>
    );
};

export default Home;
